import { Form } from 'antd';
import Forms from './styles/form.style';

const ZForm = Forms(Form);

export default ZForm;
